// extracted by mini-css-extract-plugin
module.exports = {"steps":"OnboardingPageView_steps__1PNdy","stepsCard":"OnboardingPageView_stepsCard__35BaN"};